import { memo } from 'react'
import './index.scss'
import Icon from '../Icon'
import Button from '../Button'
import { ICON } from '../Icon/data'
import { COLOR } from '../../data/variables'

type Tag = {
  label: string
  id: string | number
  color?: 'outline' | 'green' | 'magenta' | 'cyan' | 'gray' | 'cool-gray' | 'blue' | 'high-contrast' | 'teal' | 'warm-gray' | 'red'
  onClose?: (id: string | number) => void
  size?: 'm' | 's'
}

const Tag = memo(({ label, id, color = 'gray', onClose, size = 'm' }: Tag) => {
  const tagColor = {
    outline: COLOR.TEXT_GRAY,
    green: COLOR.TAG_GREEN,
    magenta: COLOR.TAG_MAGENTA,
    cyan: COLOR.TEXT_GRAY,
    'high-contrast': COLOR.WHITE,
  }
  
  return (
    <div className={`Tag size-${size} ${color}`}>
      {onClose && (
        <Button
          type="ghost"
          size="s"
          label={<Icon icon={ICON.CLOSE} color={tagColor[color] ?? COLOR.TEXT_GRAY} />}
          onClick={() => onClose(id)}
        />
      )}
      <div className="Tag__label">{label}</div>
    </div>
  )
})

export default Tag
